<template>
  <div>
  <section>
    <div class="left">
      <detail-entity-info
          :entity="entity"
          :omit-default="['id_remote']"
      >
      </detail-entity-info>
    </div>
  <div class="right">
    <div class="field_left">
      <select-box
          id="devicetype"
          :options="deviceTypeOptions"
          v-model="entity.id_device_type"
          :disabled="!isEditable || isUpdate"
          ref="devicetyperef"
      >
        <translate class="translate">Typ zařízení</translate>
      </select-box>
    </div>
    <div class="field_right">
      <select-box
          id="brand"
          :options="brandOptions"
          v-model="entity.id_brand"
          :disabled="!isEditable || isUpdate"
          ref="brandref"
      >
        <translate class="translate">Brand</translate>
      </select-box>
    </div>
    <div class="field_left">
      <checkbox-input
          id="allowpairingbymacaddress"
          v-model="entity.allow_pairing_by_mac_address"
          ref="allowpairingbymacaddress"
          :disabled="!isEditable"
      >
        <translate class="translate">Povolit párování MAC adresou</translate>
      </checkbox-input>
      <checkbox-input
          id="allowpairingbypairingcode"
          v-model="entity.allow_pairing_by_pairing_code"
          ref="allowpairingbypairingcode"
          :disabled="!isEditable"
      >
        <translate class="translate">Povolit párování párovacím kódem</translate>
      </checkbox-input>
    </div>
  </div>
  </section>
  </div>
</template>

<script>
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";

export default {
  name: "BasicForm",
  components: {DetailEntityInfo},
  props: {
    entity: Object,
    isEditable: Boolean,
    brandOptions: Array,
    deviceTypeOptions: Array,
    isUpdate: Boolean,
  },
  data(){
    return {
    }
  },
  computed: {
  },
  methods:{
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/initialProcessSetup/forms/BasicSettings.vue